import path from 'path';
import { PMS_URL, FRONTEND_ADMIN_URL } from '../../../config';

export default {
  setRoot(dispatch, getState, location) {
    const root = PMS_URL === '/'
      ? location.pathname.split('/')[1]
      : location.pathname.split(PMS_URL)[1].split('/')[1];
    dispatch({ type: 'ROUTING__SET_ROOT', payload: `/${root || ''}` });
  },
  redirect(dispatch, getState, router, url) {
    if (location.pathname.match(`^${FRONTEND_ADMIN_URL}`)) {
      router.push(path.join(FRONTEND_ADMIN_URL, url));
    } else {
      const root = getState('routing').root;
      router.push(path.join(PMS_URL, root, url));
    }
  }
};



// WEBPACK FOOTER //
// ./src/frontend/modules/routing/triggers.js